import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { useNavigate } from "react-router-dom";

const icon = (status) =>
  L.divIcon({
    className: "",
    html: `<div class="kl-marker ${status}" style="--c:${status === "active" ? "#32D74B" : "#FF453A"}"><span class="ring"></span><span class="core"></span></div>`,
    iconSize: [14, 14],
    iconAnchor: [7, 7],
    popupAnchor: [0, -10],
  });

function FlyTo({ target }) {
  const map = useMap();
  useEffect(() => { if (target && target.lat != null && target.lng != null) map.flyTo([target.lat, target.lng], 11, { duration: 1.1 }); }, [target, map]);
  return null;
}

export default function WorldMap({ devices, focus }) {
  const nav = useNavigate();
  return (
    <MapContainer center={[18, 40]} zoom={3} minZoom={2} className="h-full w-full" zoomControl={false} worldCopyJump attributionControl>
      <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}" maxZoom={16} />
      <FlyTo target={focus} />
      {/* A device has no location until the mobile app syncs GPS on first
          connect (and again after a proposal is confirmed) — skip those
          rather than plotting a marker with nothing to plot. */}
      {devices.filter((d) => d.lat != null && d.lng != null).map((d) => (
        <Marker key={d.id} position={[d.lat, d.lng]} icon={icon(d.status)}>
          <Popup>
            <div className="p-4 w-56" data-testid={`map-popup-${d.serial}`}>
              <div className="kl-label-dark">{d.status === "active" ? "● online" : "○ offline"} · {d.client_type}</div>
              <div className="font-display text-base mt-1">{d.client_name}</div>
              <div className="font-mono text-[11px] text-kl-muted mt-0.5">{d.serial}</div>
              <div className="text-xs text-kl-muted mt-1">{d.city}, {d.country}</div>
              <div className="font-mono text-sm mt-3">{d.live ? `${(d.live.power_w / 1000).toFixed(2)} kW` : "—"} <span className="text-kl-muted text-xs">live</span></div>
              <button data-testid={`map-open-${d.serial}`} onClick={() => nav(`/devices/${d.id}`)} className="kl-btn-primary w-full h-9 mt-3 text-xs">Open dashboard</button>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
